import $ from "jquery";
import axios from "axios";

var current_page = 1;
var cat_id = 0;
var can_plus_one = true;
var all = true;

// will not need anything in the url..

$(".load-more").on("click", function() {
  var $this = $(this);
  $this.addClass("loading");

  if (can_plus_one) {
    current_page++;
  }
  can_plus_one = false;

  let params = {
    firstName: "Fred",
    lastName: "Flintstone"
  };
  // params.current_page = current_page;
  // params.cat_id = cat_id;
  console.log(params);

  axios.post("/wp-admin/admin-ajax.php", params).then(res => {
    console.log({ res });
    $(".posts").append(res.data.data);
    $this.removeClass("loading");

    can_plus_one = true;
  });
});

$(".news-listings__filter .category").on("click", function() {
  var $this = $(this);
  cat_id = $this.attr("data-cat-id");
  current_page = 0;
  all = false;
});

$(".news-listings__filter .all").on("click", function() {
  all = true;
});
